interface FingerprintOpts {
  linkedId?: string;
}

export const fpGetEvent = async (options: FingerprintOpts) => {
    if (!options.linkedId) {
      return
    }
    
    const fingerprint = await (window as any).fpPromise;
    return fingerprint?.get?.(options)
};
